import tw from "twin.macro";

export const WordPackageListWrapper = tw.div`
    flex 
    flex-col
    gap-8
`;

export const SelectionWrapper = tw.div`mb-8`;
